// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2B0t5","label":"Radio_label__2If55","checkMark":"Radio_checkMark__3WlTi","disabled":"Radio_disabled__XOnZN"};